import { PUBLIC_ROUTES } from './routes/constants/publicRoutes';
import { SERVICE_ROUTES } from './routes/constants/serviceRoutes';
import { EXTERNAL_ROUTES } from './routes/constants/externalRoutes';
import { PRIVATE_ROUTES } from './routes/constants/privateRoutes';

export const ALL_ROUTES = {
  ...SERVICE_ROUTES,
  ...PUBLIC_ROUTES,
  ...PRIVATE_ROUTES,
  ...EXTERNAL_ROUTES,
};

export const ROUTES = Object.values({
  ...SERVICE_ROUTES,
  ...PUBLIC_ROUTES,
  ...EXTERNAL_ROUTES,
  ...flattenObject(PRIVATE_ROUTES, false)
});

export const ALL_PRIVATE_ROUTES = Object.values({
  ...EXTERNAL_ROUTES,
  ...flattenObject(PRIVATE_ROUTES, false)
});

export const ALL_PUBLIC_ROUTES = Object.values({
  ...flattenObject(PUBLIC_ROUTES, true)
});

function flattenObject(obj, stop, parentKey = '', result = {}) {
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    const newKey = parentKey ? `${parentKey}.${key}` : key;
    const value = obj[key];

    if (!stop && typeof value === 'object' && value !== null && !Array.isArray(value)) {
      flattenObject(value, true, newKey, result);
    } else {
      result[newKey] = value;
    }
  }

  return result;
}

export const defaultRoutes = [
  PRIVATE_ROUTES.dashboard.root,
  PRIVATE_ROUTES.account.listDS,
  PRIVATE_ROUTES.patient.list,
];

export const PATIENT_TABLE_NAMES = {
  assessment: 'assessments',
  program: 'programs',
  resource: 'resources',
  order: 'orders',
  claimsReporting: 'claimsReporting',
  claimReport: 'claimReport',
  reportable: 'reportables',
};
